export const WARNING_TITLE = 'Stop!';

export const WARNING_MESSAGE =
  'This is a browser feature intended for developers. If someone told you to copy-paste something here to enable a Unified Workforce feature or "hack" someone\'s account, it is a scam and will give them access to your Unified Workforce account.';

export const WARNING_INFO_LINK =
  'See https://en.wikipedia.org/wiki/Self-XSS for more information.';

export const TITLE_STYLE =
  'color: red; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; font-size: 50px; font-weight: bold; -webkit-text-stroke: 1px black;';

export const BODY_STYLE =
  'font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; font-size: 18px; font-weight: 500;';

/**
 * Directly prints the Self-XSS security warning to the developer console.
 */
export function displayConsoleWarning() {
  if (
    typeof window === 'undefined' ||
    typeof console === 'undefined' ||
    typeof console.log !== 'function'
  ) {
    return;
  }

  console.log(`%c${WARNING_TITLE}`, TITLE_STYLE);
  console.log(`%c${WARNING_MESSAGE}`, BODY_STYLE);
  console.log(`%c${WARNING_INFO_LINK}`, BODY_STYLE);
}

/**
 * Initializes the console warning:
 * 1. Outputs the styled warning if not already shown.
 * 2. Hooks console.clear so the warning is restored if the console is cleared.
 */
export function initConsoleWarning() {
  if (typeof window === 'undefined' || typeof console === 'undefined') {
    return;
  }

  // Avoid noisy logs during automated test runs unless explicitly testing this module
  if (process.env.NODE_ENV === 'test' && !window.__TEST_CONSOLE_WARNING__) {
    return;
  }

  if (!window.__uwConsoleWarningShown) {
    window.__uwConsoleWarningShown = true;
    displayConsoleWarning();
  }

  if (typeof console.clear === 'function' && !window.__uwConsoleClearHooked) {
    window.__uwConsoleClearHooked = true;
    const originalClear = console.clear.bind(console);
    console.clear = function (...args) {
      originalClear(...args);
      displayConsoleWarning();
    };
  }
}
